import SearchIcon from 'assets/icons/searchIcon.svg';
import { observer } from 'mobx-react';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import './drugSearchBar.modue.scss';
import { useDrugSearchBar } from './useDrugSearchBar';
import ParallelIterationsModal from 'screens/BDPortal/OpportunityTracker/components/ParallelIterationModal/ParallelIterationModal';

const DrugSearchBar = () => {
  const {
    drugSearchInput,
    serchfieldRef,
    isAllDrugsLoading,
    handleFilterDrugSearch,
    filteredDrugMoleculesForSearch,
    isSearchButtonDisabled,
    handleDrugSearchInputChange,
    handleSearch,
    handleEnterKeyDownDrugSearchField,
    isParallelIterationsModalVisibile,
    toggleIterationModalVisibility,
    selectedConceptName,
  } = useDrugSearchBar();

  return (
    <div className={'drugSearchBar'}>
      <Button
        outlined
        data-testid="drugSearchButton"
        className="searchIconButton"
        // onClick={(e) => handleEnterKeyDownDrugSearchField(e)}
        disabled={isSearchButtonDisabled()}
      >
        {!isAllDrugsLoading ? (
          <img className="searchIcon" src={SearchIcon} alt="search icon" />
        ) : (
          <ProgressSpinner
            style={{ width: '25px', height: '25px' }}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration="1s"
          />
        )}
      </Button>
      <Divider className="devider" layout="vertical" />
      <div className={'searchBarRightSide'}>
        <AutoComplete
          onLoad={() => {
            if (serchfieldRef) serchfieldRef.current?.focus();
          }}
          ref={serchfieldRef}
          autoFocus
          onSelect={e => handleSearch(e.value)}
          minLength={1}
          delay={100}
          autoHighlight={true}
          disabled={isAllDrugsLoading}
          onKeyDown={handleEnterKeyDownDrugSearchField}
          placeholder="Search Opportunity by Drug Molecule & Form"
          style={{ flexGrow: 1 }}
          className={'searchField'}
          value={drugSearchInput}
          suggestions={filteredDrugMoleculesForSearch}
          dropdownIcon={null}
          completeMethod={handleFilterDrugSearch}
          onChange={e => handleDrugSearchInputChange(e.value)}
        />
        {/* <div className={"activationContainer"}>
                    <div className={"activationField"}>
                        <Checkbox checked={isActivateSelected} onChange={toggleActivateSelected} />
                        <div className='activationLabel'>
                            Active
                        </div>
                    </div>
                    <div className={"activationField"} >
                        <Checkbox checked={isInctivateSelected} onChange={toggleInActiveSelected} />
                        <div className='activationLabel'>O
                            Inactive
                        </div>
                    </div>
                </div> */}
        {selectedConceptName !== null && isParallelIterationsModalVisibile && (
          <ParallelIterationsModal
            visibility={isParallelIterationsModalVisibile}
            toggleVisibility={toggleIterationModalVisibility}
            conceptName={selectedConceptName}
            isCreateNewIterationButtonVisible={false}
            isGoToOpportunityButtonVisible={true}
          />
        )}
      </div>
    </div>
  );
};

export default observer(DrugSearchBar);
